<template>
  <div class="trial-expires-modal">
    <div class="body">
      <div class="title">{{ $t('trial-expires.title') }}</div>
      <div class="desc">{{ $t('trial-expires.desc') }}</div>
      <kw-button
        class="kw-button package-button !mx-auto !mt-4"
        @click="openBillingPage"
        :button-text="$t('trial-expires.package.keep.button')"
      />
    </div>

    <global-events @keyup.enter="openBillingPage" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cookieSetters } from '@/helpers/cookieManager';

export default {
  name: 'TrialExpiresModal',
  mounted() {
    cookieSetters.setExpireModalShown(this.getUserDataProp('email'));
  },
  computed: {
    ...mapGetters(['getUserDataProp']),
  },
  methods: {
    openBillingPage() {
      this.$router.push({ name: 'AccountDetails' });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/modal';

.trial-expires-modal {
  font-family: 'Roboto';
  font-style: normal;
  text-align: center;
  padding: 28px 0 18px;
  max-height: inherit;
  overflow-y: auto;

  .header {
    display: flex;
    justify-content: flex-end;
    padding: 9px 11px;

    ::v-deep .button-closer {
      width: 9px;
      height: 9px;
    }
  }

  .body {
    .title {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      color: #000000;
    }

    .desc {
      margin-top: 8px;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #24242c;
    }
  }
}
</style>
